// Compatibility entry point: every existing user-name rendering now uses the
// same clickable actor reference, preview and authorization-aware resolver.
import { useEffect, useState } from 'react';
import { ActorReference } from '@/features/references/ActorReference';
import { cachedProfile, loadProfileReference, referenceScope } from '@/features/references/cache';

export function resolveUserName(id: string): string {
  return cachedProfile(id)?.name || '';
}
export function useResolvedUserName(id: string | undefined | null): string {
  const scope = referenceScope();
  const [resolved, setResolved] = useState<{ key: string; name: string }>();
  const key = `${scope}|${id || ''}`;
  useEffect(() => {
    if (!id) return;
    let active = true;
    void loadProfileReference(id, scope).then((value) => { if (active) setResolved({ key, name: value?.name || '' }); });
    return () => { active = false; };
  }, [id, key, scope]);
  return resolved?.key === key ? resolved.name : (id ? cachedProfile(id, scope)?.name || '' : '');
}
export function UserName({ id, className, fallbackLabel }: { id?: string | null; className?: string; showIdFallback?: boolean; linkToProfile?: boolean; fallbackLabel?: string }) {
  return <ActorReference id={id} className={className} fallbackLabel={fallbackLabel} showAvatar={false} />;
}
